import { shareCourse } from '../core/backup.js';
import { dbDel, dbPut, normalizeCard, normalizeDeck } from '../core/db.js';
import { decksOf } from '../core/load.js';
import { state } from '../core/state.js';
import { $, $$, esc, uid } from '../core/text.js';
import { toast } from './toast.js';
import { refresh } from './views.js';

/* ══════════ Modal ══════════ */
export function modal({ title, body, onOk, okText = 'Speichern' }) {
  $('#modal-title').textContent = title;
  $('#modal-body').innerHTML = body;
  $('#modal-ok').textContent = okText;
  $('#modal-cancel').style.display = '';
  $('#modal').classList.remove('hidden');
  const close = () => { $('#modal').classList.add('hidden'); $('#modal-ok').onclick = null; $('#modal-cancel').onclick = null; };
  $('#modal-cancel').onclick = close;
  $('#modal-ok').onclick = async () => { if (await onOk() !== false) close(); };
  return close;
}
export function newCourse() {
  modal({
    title: 'Neuer Kurs (Überdeck)',
    body: `<div class="field"><label>Name</label><input class="input" id="m-name" placeholder="z.B. Robotik I"></div>
           <div class="field"><label>Emoji</label><input class="input" id="m-emoji" placeholder="📚" maxlength="4"></div>`,
    onOk: async () => {
      const name = $('#m-name').value.trim();
      if (!name) { toast('Bitte einen Namen'); return false; }
      const course = { id: uid(), name, emoji: $('#m-emoji').value.trim() || '📚', created: Date.now(), archived: false };
      await dbPut('courses', course); state.courses.push(course);
      state.selCourse = course.id; state.selDecks.clear(); state.openCourses.add(course.id); state.coll = null;
      toast('Kurs angelegt ✦'); refresh();
    },
  });
  setTimeout(() => $('#m-name')?.focus(), 60);
}
export function newDeck(courseId) {
  modal({
    title: 'Neue Vorlesung (Unterdeck)',
    body: `<div class="field"><label>Name</label><input class="input" id="m-name" placeholder="z.B. VL 3 – Kinematik"></div>`,
    onOk: async () => {
      const name = $('#m-name').value.trim();
      if (!name) { toast('Bitte einen Namen'); return false; }
      const deck = normalizeDeck({ id: uid(), courseId, name, created: Date.now() });
      await dbPut('decks', deck); state.decks.push(deck);
      toast('Vorlesung angelegt ✦'); refresh();
    },
  });
  setTimeout(() => $('#m-name')?.focus(), 60);
}

/* Mehrere Karten / CSV: je Zeile „Frage <Trenner> Antwort" (Tab, | , – , ;) */
export function parseBulk(text) {
  const out = [];
  for (const raw of (text || '').split(/\r?\n/)) {
    const line = raw.trim();
    if (!line || line.startsWith('#')) continue;
    const m = line.match(/^(.*?)\s*(?:\t|\s\|\s|\s[–-]\s|;)\s*(.+)$/);
    if (m && m[1].trim() && m[2].trim()) out.push({ q: m[1].trim(), a: m[2].trim() });
  }
  return out;
}
export function bulkAddModal() {
  if (!state.selCourse) { toast('Wähl erst einen Kurs oder eine Vorlesung links'); return; }
  const decks = decksOf(state.selCourse);
  if (!decks.length) { toast('Leg zuerst eine Vorlesung an'); return; }
  const preferDeck = [...state.selDecks][0] || decks[0].id;
  modal({
    title: '⚡ Mehrere Karten anlegen',
    okText: 'Anlegen',
    body: `<div class="field"><label>In welche Vorlesung?</label>
             <select class="select" id="m-deck">${decks.map((d) => `<option value="${d.id}" ${d.id === preferDeck ? 'selected' : ''}>${esc(d.name)}</option>`).join('')}</select></div>
           <div class="field"><label>Je Zeile: Frage &nbsp;–&nbsp; Antwort</label>
             <textarea class="textarea" id="m-bulk" rows="9" placeholder="Paris – Hauptstadt Frankreichs&#10;H2O ; Wasser&#10;Gegenteil von hell – dunkel"></textarea></div>
           <p class="page-sub">Trennzeichen: Tab, „ | ", „ – " oder „ ; ". CSV/TXT-Datei geht auch.</p>
           <div class="row-actions"><button class="btn-ghost outline tiny" id="m-bulk-file">Aus Datei laden…</button>
             <span class="status" id="m-bulk-count" style="margin:0"></span></div>`,
    onOk: async () => {
      const pairs = parseBulk($('#m-bulk').value);
      if (!pairs.length) { toast('Keine gültigen Zeilen gefunden'); return false; }
      const deckId = $('#m-deck').value;
      const color = decks.find((d) => d.id === deckId)?.color ?? 0;
      for (const pr of pairs) {
        const rec = normalizeCard({ id: uid(), courseId: state.selCourse, deckId, front: { text: pr.q, image: null }, back: { text: pr.a, image: null }, color, created: Date.now() });
        await dbPut('cards', rec); state.cards.push(rec);
      }
      toast(`${pairs.length} Karten angelegt ✦`); refresh();
    },
  });
  const upd = () => { const n = parseBulk($('#m-bulk').value).length; $('#m-bulk-count').textContent = n ? `${n} Karten erkannt` : ''; };
  $('#m-bulk').oninput = upd;
  $('#m-bulk-file').onclick = () => {
    const inp = document.createElement('input'); inp.type = 'file'; inp.accept = '.csv,.txt,text/csv,text/plain';
    inp.onchange = () => { const f = inp.files[0]; if (!f) return; const r = new FileReader(); r.onload = () => { $('#m-bulk').value = r.result; upd(); }; r.readAsText(f); };
    inp.click();
  };
}

/* Beim allerersten Start ein Demo-Deck anlegen (nur wenn noch nichts da ist). */
export async function seedDemoIfEmpty() {
  if (localStorage.getItem('demoSeeded') || state.courses.length) return;
  localStorage.setItem('demoSeeded', '1');
  const cid = uid(), did = uid();
  const course = { id: cid, name: 'Probier mich ✨', emoji: '🐱', created: Date.now(), archived: false };
  const deck = normalizeDeck({ id: did, courseId: cid, name: 'Erste Runde', created: Date.now() });
  await dbPut('courses', course); await dbPut('decks', deck);
  state.courses.push(course); state.decks.push(deck);
  const demo = [['Wie heißt diese App?', 'mimorio'], ['Was ergibt 2 + 2?', '4'], ['Hauptstadt von Österreich?', 'Wien'],
    ['Gegenteil von „hell"?', 'dunkel'], ['Wofür steht „XP"?', 'Erfahrungspunkte']];
  for (const [q, a] of demo) {
    const rec = normalizeCard({ id: uid(), courseId: cid, deckId: did, front: { text: q, image: null }, back: { text: a, image: null }, color: 5, created: Date.now() });
    await dbPut('cards', rec); state.cards.push(rec);
  }
  state.selCourse = cid; state.openCourses.add(cid);
}
export async function delCourse(courseId) {
  const course = state.courses.find((c) => c.id === courseId);
  const n = state.cards.filter((c) => c.courseId === courseId).length;
  if (!confirm(`„${course.name}" mit ${n} Karten wirklich löschen?\n\nTipp: Archivieren behält die Karten.`)) return;
  for (const c of state.cards.filter((x) => x.courseId === courseId)) await dbDel('cards', c.id);
  for (const d of state.decks.filter((x) => x.courseId === courseId)) await dbDel('decks', d.id);
  await dbDel('courses', courseId);
  state.cards = state.cards.filter((c) => c.courseId !== courseId);
  state.decks = state.decks.filter((d) => d.courseId !== courseId);
  state.courses = state.courses.filter((c) => c.id !== courseId);
  if (state.selCourse === courseId) { state.selCourse = null; state.selDecks.clear(); }
  toast('Kurs gelöscht'); refresh();
}

export function courseModal(id) {
  const course = state.courses.find((c) => c.id === id);
  if (!course) return;
  const n = state.cards.filter((c) => c.courseId === id).length;
  modal({
    title: 'Kurs bearbeiten',
    body: `<div class="field"><label>Name</label><input class="input" id="m-name" value="${esc(course.name)}"></div>
           <div class="field"><label>Emoji</label><input class="input" id="m-emoji" maxlength="4" value="${esc(course.emoji || '')}"></div>
           <p class="page-sub">${decksOf(id).length} Vorlesungen · ${n} Karten</p>
           <label class="toggle"><input type="checkbox" id="m-public" ${course.public ? 'checked' : ''}> Kurs öffentlich im Profil zeigen</label>
           <div class="row-actions">
             <button class="btn-ghost outline tiny" id="m-share">⬆ Teilen (Datei)</button>
             <button class="btn-ghost outline tiny" id="m-arch">${course.archived ? '↩ Aus Archiv holen' : '📦 Ausblenden / Archivieren'}</button>
             <button class="btn-danger tiny" id="m-del">✕ Kurs löschen</button>
           </div>
           <p class="page-sub" style="margin-top:8px">Teilen speichert den Kurs als Datei, die andere über „Datei einspielen" importieren können. Online-Hochladen kommt mit dem Konto. <span class="soon">online</span></p>`,
    onOk: async () => {
      const name = $('#m-name').value.trim();
      if (!name) { toast('Bitte einen Namen'); return false; }
      course.name = name; course.emoji = $('#m-emoji').value.trim() || '📚';
      course.public = $('#m-public').checked;
      await dbPut('courses', course); toast('Gespeichert ✦'); refresh();
    },
  });
  $('#m-share').onclick = () => shareCourse(id);
  $('#m-arch').onclick = async () => {
    course.archived = !course.archived; await dbPut('courses', course);
    if (course.archived && !state.showArchived && state.selCourse === id) { state.selCourse = null; state.selDecks.clear(); }
    $('#modal').classList.add('hidden'); toast(course.archived ? 'Kurs archiviert 📦' : 'Kurs zurückgeholt'); refresh();
  };
  $('#m-del').onclick = async () => { $('#modal').classList.add('hidden'); await delCourse(id); };
}

export function deckModal(id) {
  const deck = state.decks.find((d) => d.id === id);
  if (!deck) return;
  const cards = state.cards.filter((c) => c.deckId === id);
  const others = state.courses.filter((c) => c.id !== deck.courseId);
  let color = deck.color || 0;
  modal({
    title: 'Vorlesung bearbeiten',
    body: `<div class="field"><label>Name</label><input class="input" id="m-name" value="${esc(deck.name)}"></div>
           ${others.length ? `<div class="field"><label>In anderen Kurs verschieben</label>
             <select class="select" id="m-move"><option value="">– hier lassen –</option>
               ${others.map((c) => `<option value="${c.id}">${esc(c.emoji || '📚')} ${esc(c.name)}</option>`).join('')}</select></div>` : ''}
           <div class="field"><label>Farbe der Vorlesung</label>
             <div class="swatches" id="m-swatches">
               ${Array.from({ length: 12 }, (_, i) => `<button class="swatch pc-${i} ${i === color ? 'sel' : ''}" data-color="${i}"></button>`).join('')}
             </div>
             <label class="toggle" style="margin-top:8px"><input type="checkbox" id="m-recolor"> Alle ${cards.length} bestehenden Karten auch umfärben</label>
           </div>
           <p class="page-sub">Neue Karten in dieser Vorlesung bekommen diese Farbe automatisch.</p>
           <div class="row-actions">
             <button class="btn-ghost outline tiny" id="m-arch">${deck.archived ? '↩ Aus Archiv holen' : '📦 Archivieren'}</button>
             <button class="btn-danger tiny" id="m-del">✕ Vorlesung löschen</button>
           </div>`,
    onOk: async () => {
      const name = $('#m-name').value.trim();
      if (!name) { toast('Bitte einen Namen'); return false; }
      deck.name = name; deck.color = color;
      const move = $('#m-move')?.value;
      if (move) { deck.courseId = move; for (const c of cards) { c.courseId = move; await dbPut('cards', c); } state.openCourses.add(move); }
      if ($('#m-recolor').checked) { for (const c of cards) { c.color = color; await dbPut('cards', c); } }
      await dbPut('decks', deck); toast('Gespeichert ✦'); refresh();
    },
  });
  $$('#m-swatches .swatch').forEach((sw) => { sw.onclick = () => { color = +sw.dataset.color; $$('#m-swatches .swatch').forEach((x) => x.classList.remove('sel')); sw.classList.add('sel'); }; });
  $('#m-arch').onclick = async () => {
    deck.archived = !deck.archived; await dbPut('decks', deck);
    if (deck.archived && !state.showArchived) state.selDecks.delete(id);
    $('#modal').classList.add('hidden'); toast(deck.archived ? 'Vorlesung archiviert 📦' : 'Vorlesung zurückgeholt'); refresh();
  };
  $('#m-del').onclick = async () => {
    if (!confirm(`„${deck.name}" mit ${cards.length} Karten wirklich löschen?\n\nTipp: Archivieren behält die Karten.`)) return;
    for (const c of cards) await dbDel('cards', c.id);
    await dbDel('decks', id);
    state.cards = state.cards.filter((c) => c.deckId !== id);
    state.decks = state.decks.filter((d) => d.id !== id);
    state.selDecks.delete(id);
    $('#modal').classList.add('hidden'); toast('Vorlesung gelöscht'); refresh();
  };
}

